import React, { Suspense } from 'react';
import { loadDatePicker } from './loadDatePicker';

const DatePicker = React.lazy(loadDatePicker);

/**
 * Drop-in for react-datepicker's default export. The library (and date-fns / floating-ui)
 * downloads the first time a calendar renders. Its CSS stays in main.css so library rules
 * keep their place at the start of the cascade and app overrides win exactly as before.
 */
class LazyDatePicker extends React.Component {
  static preload() {
    return loadDatePicker();
  }

  render() {
    const { suspenseFallback = null, ...pickerProps } = this.props;
    return (
      <Suspense fallback={suspenseFallback}>
        <DatePicker {...pickerProps} />
      </Suspense>
    );
  }
}

export default LazyDatePicker;
